enum EditTagsDrawerConstants {
  OPEN_DELETE_CATEGORY_MODAL = '@EditTagsDrawer/OPEN_DELETE_CATEGORY_MODAL',
  CLOSE_DELETE_CATEGORY_MODAL = '@EditTagsDrawer/CLOSE_DELETE_CATEGORY_MODAL',
  OPEN_DELETE_TAG_MODAL = '@EditTagsDrawer/OPEN_DELETE_TAG_MODAL',
  CLOSE_DELETE_TAG_MODAL = '@EditTagsDrawer/CLOSE_DELETE_TAG_MODAL',
  OPEN_EDIT_TAGS_DRAWER = '@EditTagsDrawer/OPEN_EDIT_TAGS_DRAWER',
  CLOSE_EDIT_TAGS_DRAWER = '@EditTagsDrawer/CLOSE_EDIT_TAGS_DRAWER',
}
export default EditTagsDrawerConstants;
